import styles from './NotFound.module.scss';

export const NotFound: React.FC = () => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>PAGE NOT FOUND</h2>
    </div>
  );
};
